<template>
  <v-navigation-drawer
    v-model="drawer"
    permanent
    width="350"
    class="o-nav pa-5"
    app
    clipped
  >
    <div class="mx-3 mt-5 mb-4 font-weight-bold text-uppercase">
      <div>Admin Section</div>
    </div>
    <v-list dense height="50">
      <v-list-item
        v-for="item in sectionList"
        :key="item.name"
        :index="item.index"
        dense
      >
        <v-list-item-content>
          <v-list-item-title class="mb-3">
            <v-icon
              small
              :class="`mr-2 mb-2 ${
                isActiveRoute(item.route)
                  ? 'o-navIcon--active'
                  : 'o-navIcon'
              }`"
              >fas fa-circle fa-fw</v-icon
            >
            <router-link
              :to="{ name: item.route }"
              :class="`o-sectionLink ${
                isActiveRoute(item.route) ? 'o-nav--active' : 'o-nav'
              }`"
              >{{ item.label }}</router-link
            >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      sectionList: [
        {
          label: "Main Menu",
          route: "ochinMenu",
        },
        {
          label: "Primary Roles",
          route: "ochinUserSecurityPrimaryRole",
        },
        {
          label: "Questions & Answers",
          route: "ochinUserSecurityQuestionApp",
        },
        {
          label: "Security Functions",
          route: "ochinUserSecurityFunction",
        },
      ],
    };
  },
  methods: {
    isActiveRoute(name) {
      return this.$route.matched.find(route => {
        return route.name === name;
      });
    },
  },
};
</script>
